module.exports = __webpack_public_path__ + "img/unminted.10dc4071.svg";